import { RouterView } from 'vue-router';

import { AGENT_ROLE } from '@/constants';
import { AccountPermission } from '@/constants/enum';
import { useAppStore } from '@/store/app';
import TabsView from '@/views/common/TabsView/index';

import { RouteName } from './names';
import { hasRoutePermission } from './utils';

const redirectToFirstChild = (to) => {
  const last = to.matched[to.matched.length - 1];
  if (!last?.children?.length) return false;

  // 找到第一个有权限的路由
  const first = last.children.find((route) => {
    return hasRoutePermission(route);
  });

  return first ? { name: first.name } : false;
};

export const mainRoutes = [
  // TODO: 临时隐藏概览页，用下方的WelcomeView代替，待产品需求完善后再开放
  // {
  //   path: '',
  //   name: RouteName.Overview,
  //   component: () => import('@/views/overview/OverviewView'),
  //   meta: { menu: true, langKey: 'lang159' }, // 权限由OverviewView内部控制
  // },
  {
    path: '',
    name: RouteName.Homepage,
    component: () => import('@/views/overview/HomeDashboard'),
    meta: { menu: true, langKey: 'lang159' },
  },
  {
    path: 'test',
    name: 'Test',
    component: () => import('@/views/overview/Testview'),
  },
  {
    path: 'admin',
    name: RouteName.Admin,
    component: RouterView,
    meta: { menu: true, langKey: 'lang161' },
    children: [
      {
        path: 'accounts',
        name: RouteName.AdminAccounts,
        component: () => import('@/views/admin/AccountsView'),
        meta: {
          menu: true,
          langKey: 'lang162',
          permissions: [
            AccountPermission.ModifyAccount,
            AccountPermission.ResetPassword,
            AccountPermission.ModifySubAccount,
          ],
        },
      },
      {
        path: 'permissions',
        name: RouteName.AdminPermissions,
        component: () => import('@/views/admin/PermissionsView'),
        meta: {
          menu: true,
          langKey: 'lang163',
          permissions: [AccountPermission.BatchAuth],
        },
      },
      {
        path: 'action-log',
        name: RouteName.AdminActionLog,
        component: () => import('@/views/admin/ActionLogView'),
        meta: {
          menu: true,
          langKey: 'lang164',
          permissions: [AccountPermission.ActionLog],
        },
      },
      {
        path: 'data-permissions',
        name: RouteName.AdminDataPermissions,
        component: () => import('@/views/admin/DataPermissionsView'),
        meta: {
          menu: true,
          langKey: 'lang165',
          permissions: [AccountPermission.DataPermission],
        },
      },
    ],
  },
  {
    path: 'broadcaster',
    name: RouteName.Broadcaster,
    component: RouterView,
    meta: { menu: true, langKey: 'lang204' },
    children: [
      // 主播招募
      {
        path: 'recruit',
        name: RouteName.BroadcasterRecruit,
        component: () => import('@/views/broadcaster/RecruitView'),
        meta: {
          menu: true,
          langKey: 'lang205',
          permissions: [AccountPermission.AgencyBroadcasterRecruitment],
        },
        redirect: redirectToFirstChild,
        children: [
          {
            path: 'list',
            name: RouteName.BroadcasterRecruitList,
            component: () => import('@/views/broadcaster/RecruitView/RecruitList.vue'),
            meta: {
              menu: false,
              permissions: [AccountPermission.AgencyBroadcasterRecruitment],
            },
          },
          {
            path: 'edit/:id',
            name: RouteName.BroadcasterAnchorInfoEdit,
            component: () => import('@/views/broadcaster/RecruitView/AnchorInfoEdit.vue'),
            meta: {
              menu: false,
              permissions: [AccountPermission.AgencyBroadcasterRecruitment],
            },
          },
          {
            path: 'progress/:id',
            name: RouteName.BroadcasterRecruitProgress,
            component: () => import('@/views/broadcaster/RecruitView/ProgressMobile.vue'),
            meta: {
              menu: false,
              permissions: [AccountPermission.AgencyBroadcasterRecruitment],
            },
          },
          {
            path: 'recommend-hosts',
            name: RouteName.RecommendHosts,
            component: () => import('@/views/broadcaster/RecruitView/RecommendHosts.vue'),
            meta: {
              permissions: [AccountPermission.AgencyBroadcasterRecruitment],
            },
          },
        ],
      },
      // 主播列表
      {
        path: 'list',
        name: RouteName.BroadcasterListIndex,
        // component: RouterView,
        component: () => import('@/views/broadcaster/BroadcasterListView'),
        meta: {
          menu: true,
          langKey: 'lang206',
          permissions: [AccountPermission.AgencyBroadcasterList],
        },
        redirect: redirectToFirstChild,
        children: [
          {
            path: 'list',
            name: RouteName.BroadcasterList,
            component: () =>
              import('@/views/broadcaster/BroadcasterListView/BroadcasterListView.vue'),
            meta: {
              menu: false,
              permissions: [AccountPermission.AgencyBroadcasterList],
            },
          },
        ],
      },
      {
        path: 'recheck-list',
        name: RouteName.BroadcasterRecheckList,
        component: () => import('@/views/broadcaster/BroadcasterRecheckList/index.vue'),
        meta: {
          menu: false,
          langKey: 'lang1434',
          permissions: [AccountPermission.AgencyBroadcasterList],
        },
      },
      // 主播直播数据
      {
        path: 'broadcaster-live-data/:uid',
        name: RouteName.BroadcasterLiveData,
        component: () => import('@/views/broadcaster/BroadcasterLiveData'),
        meta: {
          menu: false,
          permissions: [
            AccountPermission.AgencyBroadcasterList,
            AccountPermission.LiveDataAnalysis,
            AccountPermission.BroadcasterLiveData,
          ],
        },
        beforeEnter: (to, from) => {
          console.log('11111beforeEnter');
          console.log('11111to', to);
          console.log('11111from', from);
          const pathData = {
            name: from.name,
            langKey: from.meta.langKey,
          };
          sessionStorage.setItem('breadcrumbPath', JSON.stringify(pathData));
        },
        children: [],
      },
      {
        path: 'detail/:type',
        name: RouteName.LiveDataDetailAlias,
        alias: 'live-detail/:type',
        component: () => import('@/views/live-data/DataAnalysis/Detail.vue'),
        meta: {
          permissions: [
            AccountPermission.AgencyBroadcasterList,
            AccountPermission.LiveDataAnalysis,
            AccountPermission.BroadcasterLiveData,
          ],
        },
      },
      {
        path: 'desc/:type',
        name: RouteName.LiveDataDescAlias,
        alias: 'live-desc/:type',
        component: () => import('@/views/live-data/DataAnalysis/Desc.vue'),
        meta: {
          permissions: [
            AccountPermission.AgencyBroadcasterList,
            AccountPermission.LiveDataAnalysis,
            AccountPermission.BroadcasterLiveData,
          ],
        },
      },
      // 主播关系变更
      {
        path: 'modify',
        name: RouteName.BroadcasterModifyIndex,
        component: () => import('@/views/broadcaster/RelationModify'),
        meta: {
          menu: true,
          langKey: 'lang937',
          permissions: [AccountPermission.TransferRelation],
        },
        redirect: redirectToFirstChild,
        children: [
          {
            path: 'modify',
            name: RouteName.BroadcasterModify,
            component: () => import('@/views/broadcaster/RelationModify/RelationModifyView.vue'),
            meta: {
              menu: false,
              permissions: [AccountPermission.TransferRelation],
            },
          },
        ],
      },
    ],
  },
  // 主播运营
  {
    path: 'broadcaster-operate',
    name: RouteName.BroadcasterOperate,
    component: RouterView,
    meta: {
      menu: true,
      langKey: 'lang891',
      permissions: [AccountPermission.AssignPkList],
    },
    children: [
      {
        path: 'assign-pk', // 分配pk对手
        name: RouteName.AssignPkIndex,
        meta: {
          menu: true,
          langKey: 'lang892',
          permissions: [AccountPermission.AssignPkList],
        },
        redirect: redirectToFirstChild,
        children: [
          {
            path: 'list',
            name: RouteName.AssignPkList,
            component: () => import('@/views/broadcaster-operate/assign-pk/list.vue'),
            meta: {
              permissions: [AccountPermission.AssignPkList],
            },
          },
        ],
      },
      {
        path: 'act-regist', // 主播活动报名
        name: RouteName.ActRegist,
        meta: {
          menu: true,
          langKey: 'lang1125',
          permissions: [AccountPermission.ActRegist],
        },
        redirect: redirectToFirstChild,
        children: [
          {
            path: 'list',
            name: RouteName.ActRegistList,
            component: () => import('@/views/broadcaster-operate/act-regist/index.vue'),
            meta: {
              permissions: [AccountPermission.ActRegist],
            },
          },
          {
            path: 'act-detail',
            name: RouteName.ActDetail,
            component: () => import('@/views/broadcaster-operate/act-regist/detail.vue'),
            meta: {
              permissions: [AccountPermission.ActRegist],
            },
          },
        ],
      },
      {
        path: 'act-regist-result', // 报名结果
        name: RouteName.ActRegistResult,
        component: () => import('@/views/broadcaster-operate/act-regist/result.vue'),
        meta: {
          menu: true,
          langKey: 'lang1126',
          permissions: [AccountPermission.ActRegist],
        },
        redirect: redirectToFirstChild,
        children: [
          {
            path: 'schedule',
            name: RouteName.ActRegistSchedule,
            component: () => import('@/views/broadcaster-operate/act-regist/stageSchedule.vue'),
            meta: {
              tab: true,
              langKey: 'lang1153',
              permissions: [AccountPermission.ActRegist],
            },
          },
          {
            path: 'info',
            name: RouteName.ActRegistInfo,
            component: () => import('@/views/broadcaster-operate/act-regist/registInfo.vue'),
            meta: {
              tab: true,
              langKey: 'lang1152',
              permissions: [AccountPermission.ActRegist],
            },
          },
        ],
      },
    ],
  },
  // 公会经营
  {
    path: 'guild',
    name: RouteName.Guild,
    component: RouterView,
    meta: { menu: true, langKey: 'lang211' },
    children: [
      // 安全中心
      {
        path: 'security',
        name: RouteName.GuildSecurity,
        component: TabsView,
        meta: {
          menu: true,
          langKey: 'lang212',
          permissions: [AccountPermission.AgencyGuildSecurity],
        },
        redirect: redirectToFirstChild,
        children: [
          // 状态查询
          {
            path: 'status',
            name: RouteName.GuildSecurityStatus,
            component: () => import('@/views/guild/security/StatusView'),
            meta: { tab: true, langKey: 'lang213' },
          },
          // 违规记录
          {
            path: 'violations',
            name: RouteName.GuildSecurityViolations,
            component: () => import('@/views/guild/security/ViolationsView'),
            meta: { tab: true, langKey: 'lang214' },
          },
        ],
      },
      // 团队管理
      {
        path: 'team',
        name: RouteName.GuildTeam,
        component: () => import('@/views/guild/TeamView'),
        meta: {
          menu: true,
          langKey: 'lang215',
          permissions: [AccountPermission.AgencyGuildTeam],
        },
      },
    ],
  },
  {
    path: 'data-center',
    name: RouteName.DataCenter,
    component: RouterView,
    meta: { menu: true, langKey: 'lang813' },
    // redirect: redirectToFirstChild,
    children: [
      {
        path: 'live-data',
        name: RouteName.LiveData,
        component: () => import('@/views/live-data/DataAnalysis/index.vue'),
        redirect: redirectToFirstChild,
        meta: {
          menu: true,
          langKey: 'lang683',
          permissions: [AccountPermission.LiveDataAnalysis, AccountPermission.BroadcasterLiveData],
        },
        children: [
          {
            path: 'core',
            name: RouteName.LiveDataCore,
            component: () => import('@/views/live-data/DataAnalysis/Core.vue'),
            meta: {
              tab: true,
              langKey: 'lang657',
              permissions: [
                AccountPermission.LiveDataAnalysis,
                AccountPermission.BroadcasterLiveData,
              ],
            },
          },
          // 运营视角live
          {
            path: 'proxyLive',
            name: RouteName.LiveDataProxyLive,
            component: () => import('@/views/live-data/DataAnalysis/Live.vue'),
            meta: {
              tab: true,
              langKey: 'lang658',
              permissions: [
                AccountPermission.LiveDataAnalysis,
                AccountPermission.BroadcasterLiveData,
              ],
            },
          },
          {
            path: 'live',
            name: RouteName.LiveDataLive,
            component: () => import('@/views/live-data/DataAnalysis/Live.vue'),
            meta: {
              tab: true,
              langKey: 'lang658',
              permissions: [
                AccountPermission.LiveDataAnalysis,
                AccountPermission.BroadcasterLiveData,
              ],
            },
          },
          // 78062 主播数据tab搬到data center菜单下
          // 运营视角anchor
          // {
          //   path: 'proxy',
          //   name: RouteName.LiveDataProxy,
          //   component: () => import('@/views/live-data/DataAnalysis/Anchor.vue'),
          //   meta: {
          //     tab: true,
          //     langKey: 'lang659',
          //     permissions: [
          //       AccountPermission.LiveDataAnalysis,
          //       AccountPermission.BroadcasterLiveData,
          //     ],
          //   },
          // },
          // {
          //   path: 'anchor',
          //   name: RouteName.LiveDataAnchor,
          //   component: () => import('@/views/live-data/DataAnalysis/Anchor.vue'),
          //   meta: {
          //     tab: true,
          //     langKey: 'lang659',
          //     permissions: [
          //       AccountPermission.LiveDataAnalysis,
          //       AccountPermission.BroadcasterLiveData,
          //     ],
          //   },
          // },
          {
            path: 'pk',
            name: RouteName.LiveDataPK,
            component: () => import('@/views/live-data/DataAnalysis/PK.vue'),
            meta: {
              tab: true,
              langKey: 'lang660',
              permissions: [
                AccountPermission.LiveDataAnalysis,
                AccountPermission.BroadcasterLiveData,
              ],
            },
          },
          // 代理列表
          {
            path: 'proxy-detail/:type',
            name: RouteName.LiveDataProxyDetail,
            component: () => import('@/views/live-data/DataAnalysis/Detail.vue'),
            meta: {
              permissions: [
                AccountPermission.LiveDataAnalysis,
                AccountPermission.BroadcasterLiveData,
              ],
            },
          },
          {
            path: 'detail/:type',
            name: RouteName.LiveDataDetail,
            component: () => import('@/views/live-data/DataAnalysis/Detail.vue'),
            meta: {
              permissions: [
                AccountPermission.LiveDataAnalysis,
                AccountPermission.BroadcasterLiveData,
              ],
            },
          },
          {
            path: 'desc/:type',
            name: RouteName.LiveDataDesc,
            component: () => import('@/views/live-data/DataAnalysis/Desc.vue'),
            meta: {
              permissions: [
                AccountPermission.LiveDataAnalysis,
                AccountPermission.BroadcasterLiveData,
              ],
            },
          },
        ],
      },
      {
        path: 'broadcaster-data',
        name: RouteName.DataCenterBroadcasterData,
        component: () => import('@/views/live-data/DataAnalysis/index.vue'),
        meta: { menu: true, langKey: 'lang659' },
        redirect: redirectToFirstChild,
        children: [
          // 运营视角anchor
          {
            path: 'proxy',
            name: RouteName.LiveDataProxy,
            component: () => import('@/views/live-data/DataAnalysis/Anchor.vue'),
            meta: {
              permissions: [AccountPermission.BroadcasterLiveData],
            },
          },
          {
            path: 'anchor',
            name: RouteName.LiveDataAnchor,
            component: () => import('@/views/live-data/DataAnalysis/Anchor.vue'),
            meta: {
              permissions: [AccountPermission.BroadcasterLiveData],
            },
          },
        ],
      },
      {
        path: 'broadcaster-stats',
        name: RouteName.DataCenterBroadcasterStats,
        component: TabsView,
        meta: { menu: true, langKey: 'lang172' },
        redirect: redirectToFirstChild,
        children: [
          {
            path: 'day',
            name: RouteName.DataCenterBroadcasterStatsDay,
            component: () => import('@/views/live-data/broadcaster-stats/AgencyDayView'),
            meta: { tab: true, langKey: 'lang173', permissions: [AccountPermission.AgencyStat] },
          },
          {
            path: 'month',
            name: RouteName.DataCenterBroadcasterStatsMonth,
            component: () => import('@/views/live-data/broadcaster-stats/AgencyMonthView'),
            meta: { tab: true, langKey: 'lang174', permissions: [AccountPermission.AgencyStat] },
          },
        ],
      },
      {
        path: 'team-data',
        name: RouteName.DataCenterTeamData,
        component: () => import('@/views/live-data/TeamData'),
        meta: {
          menu: true,
          langKey: 'lang1569',
        },
        beforeEnter: () => {
          const appStore = useAppStore();
          return appStore.agentRole === AGENT_ROLE.BROKER ? { name: RouteName.Homepage } : true;
        },
      },
      {
        path: 'new-broadcaster-data',
        name: RouteName.NewBroadcasterData,
        meta: { menu: true, langKey: 'lang1321' },
        redirect: redirectToFirstChild,
        children: [
          // 运营/管理员、代理都先进此页，在组件层面做身份判断，避免冗余路由
          {
            path: 'manager',
            name: RouteName.NewBroadcasterManagerData,
            component: () => import('@/views/live-data/newBroadcaster/index.vue'),
            meta: {
              permissions: [AccountPermission.NewBroadcasterData],
            },
          },
          // 管理员查看代理的数据（代理数据页）
          {
            path: 'agent',
            name: RouteName.NewBroadcasterAgentData,
            component: () => import('@/views/live-data/newBroadcaster/AgentDetail.vue'),
            meta: {
              permissions: [AccountPermission.NewBroadcasterData],
            },
          },
          // 主播数据详情
          {
            path: 'anchor-detail',
            name: RouteName.NewBroadcasterDataDetail,
            component: () => import('@/views/live-data/newBroadcaster/AnchorDetail.vue'),
            meta: {
              permissions: [AccountPermission.NewBroadcasterData],
            },
          },
        ],
      },
    ],
  },
  {
    path: 'region',
    name: RouteName.Region,
    component: RouterView,
    meta: { menu: true, langKey: 'lang176' },
    children: [
      {
        path: 'broadcaster-stats',
        name: RouteName.RegionBroadcasterStats,
        component: TabsView,
        meta: { menu: true, langKey: 'lang177' },
        redirect: redirectToFirstChild,
        children: [
          {
            path: 'day',
            name: RouteName.RegionBroadcasterStatsDay,
            component: () => import('@/views/region/broadcaster-stats/OperatorDayView'),
            meta: { tab: true, langKey: 'lang178', permissions: [AccountPermission.OperatorStat] },
          },
          {
            path: 'month',
            name: RouteName.RegionBroadcasterStatsMonth,
            component: () => import('@/views/region/broadcaster-stats/OperatorMonthView'),
            meta: { tab: true, langKey: 'lang179', permissions: [AccountPermission.OperatorStat] },
          },
          {
            path: 'agency-data',
            name: RouteName.RegionBroadcasterStatsAgencyData,
            component: () => import('@/views/region/broadcaster-stats/AgencyDataView'),
            meta: { tab: true, langKey: 'lang180', permissions: [AccountPermission.OperatorStat] },
          },
        ],
      },
    ],
  },
  {
    path: 'notification',
    name: RouteName.Notification,
    component: () => import('@/views/notification/NotificationView'),
    meta: { menu: true, langKey: 'lang216', permissions: [AccountPermission.AgencyNotification] },
  },
  {
    path: 'payment',
    name: RouteName.Payment,
    component: RouterView,
    meta: { menu: true, langKey: 'lang181' },
    children: [
      {
        path: 'distribution-upload',
        name: RouteName.PaymentDistributionUpload,
        component: () => import('@/views/payment/DistributionUploadView'),
        meta: {
          menu: true,
          langKey: 'lang182',
          permissions: [AccountPermission.PaymentDistributionUpload],
        },
      },
      {
        path: 'distribution-adjustment',
        name: RouteName.PaymentDistributionAdjustment,
        component: () => import('@/views/payment/DistributionAdjustmentView'),
        meta: {
          menu: true,
          langKey: 'lang183',
          permissions: [AccountPermission.PaymentDistributionBackend],
        },
      },
      {
        path: 'payment-transfer',
        name: RouteName.PaymentTransfer,
        component: () => import('@/views/payment/PaymentTransferView'),
        meta: {
          menu: true,
          langKey: 'lang184',
          permissions: [AccountPermission.PaymentDistributionBackend],
        },
      },
      {
        path: 'blacklist',
        name: RouteName.PaymentBlacklist,
        component: () => import('@/views/payment/BlacklistView'),
        meta: { menu: true, langKey: 'lang185', permissions: [AccountPermission.PaymentBlacklist] },
      },
      {
        path: 'action-log',
        name: RouteName.PaymentActionLog,
        component: () => import('@/views/payment/ActionLogView'),
        meta: { menu: true, langKey: 'lang186', permissions: [AccountPermission.PaymentActionLog] },
      },
      {
        path: 'broadcaster-payment',
        name: RouteName.PaymentBroadcasterPayment,
        component: TabsView,
        meta: { menu: true, langKey: 'lang187' },
        redirect: redirectToFirstChild,
        children: [
          {
            path: 'by-beans',
            name: RouteName.PaymentBroadcasterPaymentByBeans,
            component: () => import('@/views/payment/broadcaster-payment/ByBeansView'),
            meta: { tab: true, langKey: 'lang188', permissions: [AccountPermission.PaymentMethod] },
          },
          {
            path: 'action-log',
            name: RouteName.PaymentBroadcasterPaymentActionLog,
            component: () => import('@/views/payment/broadcaster-payment/ActionLogView'),
            meta: { tab: true, langKey: 'lang189', permissions: [AccountPermission.PaymentMethod] },
          },
        ],
      },
      {
        path: 'agency-payment',
        name: RouteName.PaymentAgencyPayment,
        component: TabsView,
        meta: { menu: true, langKey: 'lang190' },
        redirect: redirectToFirstChild,
        children: [
          {
            path: 'by-beans-whitelist',
            name: RouteName.PaymentAgencyPaymentByBeansWhitelist,
            component: () => import('@/views/payment/agency-payment/ByBeansWhitelistView'),
            meta: { tab: true, langKey: 'lang191', permissions: [AccountPermission.PaymentMethod] },
          },
          {
            path: 'by-beans',
            name: RouteName.PaymentAgencyPaymentByBeans,
            component: () => import('@/views/payment/agency-payment/ByBeansView'),
            meta: { tab: true, langKey: 'lang192', permissions: [AccountPermission.PaymentMethod] },
          },
          {
            path: 'bank-info',
            name: RouteName.PaymentAgencyPaymentBankInfo,
            component: () => import('@/views/payment/agency-payment/BankInfoView'),
            meta: {
              tab: true,
              langKey: 'lang193',
              permissions: [AccountPermission.PaymentMethodBankInfo],
            },
          },
          {
            path: 'action-log',
            name: RouteName.PaymentAgencyPaymentActionLog,
            component: () => import('@/views/payment/agency-payment/ActionLogView'),
            meta: { tab: true, langKey: 'lang194', permissions: [AccountPermission.PaymentMethod] },
          },
        ],
      },
      {
        path: 'by-beans-method',
        name: RouteName.PaymentByBeansMethod,
        component: () => import('@/views/payment/ByBeansMethodView'),
        meta: {
          menu: true,
          langKey: 'lang195',
          permissions: [AccountPermission.AgencyPaymentMethod],
        },
      },
    ],
  },
  {
    path: 'interview',
    name: RouteName.Interview,
    component: RouterView,
    meta: { menu: true, langKey: 'lang196', permissions: [AccountPermission.InterviewPermission] },
    children: [
      {
        path: 'list',
        name: RouteName.InterviewList,
        component: () => import('@/views/interview/InterviewListView'),
        meta: { menu: true, langKey: 'lang197' },
      },
    ],
  },
  {
    path: ':pathMatch(.*)*',
    name: RouteName.NotFound,
    component: () => import('@/views/common/NotFoundView'),
  },
  {
    path: 'no-permission', // 不符合条件
    name: RouteName.ApplyNoPermission,
    component: () => import('@/views/apply/AgentApplyFail.vue'),
    meta: { langKey: 'lang528' },
  },
  {
    path: 'apply-form', // 申请表单
    name: RouteName.ApplyForm,
    component: () => import('@/views/apply/AgentApplyForm.vue'),
    meta: { langKey: 'lang529' },
  },
  {
    path: 'apply-process', // 申请进度
    name: RouteName.ApplyProcess,
    meta: { langKey: 'lang531' },
    component: () => import('@/views/apply/AgentApplyProcess.vue'),
  },
  {
    path: 'apply-contact', // 认证-合同确认
    name: RouteName.AgentContact,
    meta: { langKey: 'lang530' },
    component: () => import('@/views/apply/AgentContact.vue'),
  },
  {
    path: 'apply-certify', // 认证表单
    name: RouteName.AgentCertifyForm,
    meta: { langKey: 'lang538' },
    component: () => import('@/views/apply/AgentCertifyForm.vue'),
  },
  {
    path: 'apply-sub-agent-list', // 申请成为子代理/经纪人
    name: RouteName.SubAgentApplyList,
    meta: { langKey: 'lang1061' },
    component: () => import('@/views/apply/SubAgentApplyList.vue'),
  },
  {
    path: 'apply-progress/:id', // 申请进度
    name: RouteName.SubAgentApplyProgress,
    meta: { langKey: 'lang1113' },
    component: () => import('@/views/apply/SubAgentApplyProgress.vue'),
  },
  {
    path: 'apply-progress-mobile/:id', // 申请进度
    name: RouteName.SubAgentApplyProgressMobile,
    meta: { langKey: 'lang1113' },
    component: () => import('@/views/apply/SubAgentApplyProgressMobile.vue'),
  },
  {
    path: 'im-determine-route/:id', // 申请im 判断路径
    name: RouteName.ImDetermineRoute,
    component: () => import('@/views/apply/ImDetermineRoute.vue'),
  },
  {
    path: 'agency-academy',
    name: RouteName.AgencyAcademy,
    component: () => import('@/views/academy/ViewWrap.vue'),
    meta: {
      langKey: 'lang1383',
      menu: true,
      permissions: [AccountPermission.BigoTutorialEntry],
    },
    redirect: redirectToFirstChild,
    children: [
      {
        path: 'course', // 代理学院
        name: RouteName.AgencyAcademyList,
        meta: {
          menu: false,
          permissions: [AccountPermission.BigoTutorialEntry],
        },
        component: () => import('@/views/academy/Home/index.vue'),
      },
      {
        path: 'course/:id', // 课程详情
        name: RouteName.AgencyAcademyDetail,
        meta: {
          menu: false,
          permissions: [AccountPermission.BigoTutorialEntry],
        },
        component: () => import('@/views/academy/Detail/index.vue'),
      },
    ],
  },
];

export default [
  {
    path: '/',
    name: RouteName.Main,
    component: () => import('@/views/common/MainView'),
    children: mainRoutes,
  },
  {
    path: '/login',
    name: RouteName.Login,
    component: () => import('@/views/common/LoginView'),
  },
];
